import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'
import { CheckIn } from '../types'

const useGetCheckIns = (): [() => Promise<CheckIn[]>, Status<CheckIn[]>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<CheckIn[]>()

  const getCheckIns = useCallback(() => {
    return request({
      method: 'get',
      url: `/organizations/${organization.id}/check-ins`,
    })
  }, [organization.id, request])

  return [getCheckIns, status]
}

export default useGetCheckIns
